import React from 'react';
import { List, useDynamicRowHeight } from 'react-window';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import LinkWithSourcePath from 'utils/LinkWithSourcePath';
import oIconLibrary from 'utils/iconLibrary';
import { fnHighlightSearchResult, fnGetIconByType } from './helpers';

const QuickSearchResultRow = ({ index, style, aResultsList, setSelection }) => {
  const oItem = aResultsList[index];
  const sType = oItem.fields.type[0];
  const bIsConstituent = sType === 'constituent';
  const onMouseDown = (e) => {
    // only react to the primary (left) mouse button
    if (e.button === 0) {
      setSelection({
        NAME: oItem.fields.name[0],
        LOOKUPID: oItem.id,
        TYPE: sType,
      });
    }
  };
  const sIconName = fnGetIconByType(sType);

  const itemMarkup = (
    <>
      <span className='quickSearchResult__icon'>
        <FontAwesomeIcon icon={oIconLibrary.fontAwesome[sIconName]} />
      </span>
      <span
        className='quickSearchResult__name'
        dangerouslySetInnerHTML={{ __html: fnHighlightSearchResult(oItem) }}
      />
    </>
  );

  return (
    <div style={style} className='quickSearchResult__wrapper'>
      {bIsConstituent ? (
        <LinkWithSourcePath
          className='quickSearchResult'
          to={`/main/profile/${oItem.id}`}
          referringComponent='QuickSearch'
        >
          {itemMarkup}
        </LinkWithSourcePath>
      ) : (
        <button
          type='button'
          className='quickSearchResult'
          onMouseDown={onMouseDown}
        >
          {itemMarkup}
        </button>
      )}
    </div>
  );
};

QuickSearchResultRow.propTypes = {
  index: PropTypes.number.isRequired,
  style: PropTypes.shape({}).isRequired,
  aResultsList: PropTypes.array.isRequired,
  setSelection: PropTypes.func.isRequired,
};

const QuickSearchSelectResultsList = ({
  setSelection,
  aResultsList,
  sUserQuery,
}) => {
  /* Show the "no results found" message when:
       -no filtered suggestions are available,
       -and user has typed in the minimum number of characters.
  */
  const bShowNoResultsFoundMsg =
    sUserQuery.length > 0 && aResultsList?.length === 0;

  const iOverallHeight =
    aResultsList?.length > 8 ? 320 : 56 * (aResultsList || []).length + 10;

  const rowHeight = useDynamicRowHeight({ defaultRowHeight: 56 });

  if (bShowNoResultsFoundMsg) {
    return (
      <p className='quickSearchSelect__noResultsMsg'>{`No results found for "${sUserQuery}"`}</p>
    );
  }

  return (
    <List
      rowComponent={QuickSearchResultRow}
      rowCount={aResultsList?.length ?? 0}
      rowHeight={rowHeight}
      rowProps={{ aResultsList, setSelection }}
      overscanCount={5}
      style={{ height: iOverallHeight, width: '100%' }}
    />
  );
};

QuickSearchSelectResultsList.propTypes = {
  aResultsList: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
    .isRequired,
  setSelection: PropTypes.func.isRequired,
  sUserQuery: PropTypes.string,
};

export default QuickSearchSelectResultsList;
